import type { FulfilmentDTO } from "../use-get-tax-payers/FulfilmentDTO";
import type { OwnerApp } from "../../dtos/OwnerApp";
import type { Operator } from "../use-get-subjects/SubjectsDto";
import type { FulfilmentSchemaDTO } from "../use-get-tax-submissions/TaxSubmissionDTO";
import { TaxSubmissionStatus } from "../../dtos/TaxSubmissionStatus";

export enum IntermediaryType {
    COMPANY = "C",
    PERSON = "P",
}

export enum GovernmentAgencyType {
    ade = "ADE",
    sdi = "SDI",
    inps = "INPS",
    tesseraSanitaria = "TS",
}

export interface Intermediary {
    taxId: string;
    siteCode: string;
    type: IntermediaryType;
}

export interface GovernmentAgency {
    type: GovernmentAgencyType;
    sendDate?: string;
    id?: string;
}

export interface Revocation {
    revokes?: string;
    revokedBy?: string;
}

export enum ActionType {
    SEND_AWAITING = "SEND_AWAITING",
    SEND_REJECTED = "SEND_REJECTED",
    UPDATE_AGENCY_ID = "UPDATE_AGENCY_ID",
    UPDATE_DELEGATED = "UPDATE_DELEGATED",
}

export type Action = {
    type: ActionType;
    date: Date;
    operator: Operator;
};

export interface TaxSubmissionDetailDTO {
    id: string;
    type: string;
    creationDate: string;
    operatorGivenName?: string;
    operatorFamilyName?: string;
    intermediary: Intermediary;
    delegatedTaxId: string | null;
    fulfilmentsErrors: number;
    fulfilmentSchema: FulfilmentSchemaDTO;
    fulfilments: FulfilmentDTO[];
    isRevocable: boolean;
    isAgencyDataEditable: boolean;
    isTaxSubmissionDeletable: boolean;
    isDelegatedEditable: boolean;
    governmentAgency: GovernmentAgency;
    status: TaxSubmissionStatus;
    outcomeTypes: string[];
    revocation?: Revocation;
    actions?: Action[];
    ownerApp: OwnerApp;
}
